import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-400">大家都在关注的热门话题，点击探索更多国产吃瓜内容</p>
        </div>

        <div className="flex flex-wrap gap-3">
          {topicsData.map((topic) => (
            <div
              key={topic.id}
              className={`group cursor-pointer flex items-center gap-3 px-4 py-3 rounded-xl border border-background-200/60 hover:border-primary-200/50 transition-all duration-300 ${topic.color}`}
            >
              <span className="text-sm font-bold whitespace-nowrap">{topic.name}</span>
              <span className="flex items-center gap-1 text-xs opacity-70">
                {topic.trend === 'hot' ? (
                  <i className="ri-fire-line text-accent-500"></i>
                ) : topic.trend === 'up' ? (
                  <i className="ri-arrow-up-line"></i>
                ) : (
                  <i className="ri-subtract-line"></i>
                )}
                {topic.heat}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}